(function () {
  function parseScore(scoreString) {
    return String(scoreString || '')
      .split(',')
      .reduce(function (scores, pair) {
        var parts = pair.split(':');
        var key = parts[0] && parts[0].trim();
        var value = Number(parts[1]);

        if (key && Number.isFinite(value)) {
          scores[key] = value;
        }

        return scores;
      }, {});
  }

  function getWhy(seriesKey) {
    var reasons = {
      vertical_fold: 'Best fit for running-focused home use, higher capability and vertical-fold storage.',
      foldable_classic: 'Best fit for a familiar treadmill feel with a fold-away design after use.',
      just_walk: 'Best fit for simple daily walking, workday movement and smaller home setups.',
      hybrid: 'Best fit for under-desk walking with the option to raise the handrail for casual running.'
    };

    return reasons[seriesKey] || reasons.just_walk;
  }

  // Rank all available series by score desc, then priceNumeric desc as tie-breaker.
  // Returns array of {key, score} sorted from best to worst match.
  function rankSeries(section, seriesByKey, availableKeys, fallbackKey) {
    var totals = {};
    availableKeys.forEach(function (key) { totals[key] = 0; });

    section.querySelectorAll('.wp-selector-option.is-selected').forEach(function (button) {
      var scores = parseScore(button.getAttribute('data-score'));
      Object.keys(scores).forEach(function (key) {
        if (key in totals) {
          totals[key] += scores[key];
        }
      });
    });

    return availableKeys
      .slice()
      .sort(function (a, b) {
        if (totals[b] !== totals[a]) {
          return totals[b] - totals[a];
        }
        // Tie-break: higher price first.
        var priceA = Number((seriesByKey[a] && seriesByKey[a].priceNumeric) || 0);
        var priceB = Number((seriesByKey[b] && seriesByKey[b].priceNumeric) || 0);
        if (priceB !== priceA) {
          return priceB - priceA;
        }
        // Final tie-break: fallback (default) goes first.
        if (a === fallbackKey) return -1;
        if (b === fallbackKey) return 1;
        return 0;
      })
      .map(function (key) {
        return { key: key, score: totals[key] };
      });
  }

  function updatePrimary(section, series, seriesKey) {
    var result = section.querySelector('[data-result-series]');
    if (!result || !series) return;

    result.setAttribute('data-result-series', seriesKey);

    var name = result.querySelector('[data-result-name]');
    var model = result.querySelector('[data-result-model]');
    var why = result.querySelector('[data-result-why]');
    var price = result.querySelector('[data-result-price]');
    var image = result.querySelector('[data-result-image]');
    var media = result.querySelector('.wp-result-card__media');
    var primary = result.querySelector('[data-result-primary]');
    var secondary = result.querySelector('[data-result-secondary]');

    if (name) name.textContent = series.name || 'Recommended series';
    if (model) model.textContent = series.model ? 'Representative model: ' + series.model : 'Representative model';
    if (why) why.textContent = getWhy(seriesKey);

    // Product main image — swap it in with the recommendation; hide the stage if none.
    if (image) {
      if (series.image) {
        image.src = series.image;
        if (series.image2x) {
          image.setAttribute('srcset', series.image + ' 1x, ' + series.image2x + ' 2x');
        } else {
          image.removeAttribute('srcset');
        }
        image.alt = series.imageAlt || series.name || '';
        if (media) media.removeAttribute('hidden');
      } else if (media) {
        media.setAttribute('hidden', '');
      }
    }

    if (price) {
      if (series.price) {
        price.textContent = series.price;
        price.removeAttribute('hidden');
      } else {
        price.textContent = '';
        price.setAttribute('hidden', '');
      }
    }

    if (primary) {
      primary.textContent = series.primaryCta || 'View model';
      primary.href = series.productUrl || series.seriesUrl || '#';
      primary.setAttribute('data-series-key', seriesKey);
    }

    if (secondary) {
      secondary.textContent = series.secondaryCta || 'Explore series';
      secondary.href = series.seriesUrl || series.productUrl || '#';
      secondary.setAttribute('data-series-key', seriesKey);
    }

    window.dispatchEvent(
      new CustomEvent('wp-series-selector:recommendation', {
        detail: {
          sectionId: section.getAttribute('data-section-id'),
          seriesKey: seriesKey,
          seriesName: series.name || '',
          model: series.model || ''
        }
      })
    );
  }

  function updateSecondary(section, series, seriesKey) {
    var card = section.querySelector('[data-result-secondary-series]');
    if (!card) return;

    if (!series) {
      card.setAttribute('hidden', '');
      return;
    }

    card.removeAttribute('hidden');
    card.setAttribute('data-result-secondary-series', seriesKey);

    var name = card.querySelector('[data-secondary-name]');
    var link = card.querySelector('[data-secondary-link]');
    var thumb = card.querySelector('[data-secondary-thumb]');
    var thumbImg = card.querySelector('[data-secondary-image]');

    if (thumb && thumbImg) {
      if (series.image) {
        thumbImg.src = series.image;
        thumbImg.alt = series.imageAlt || series.name || '';
        thumb.removeAttribute('hidden');
      } else {
        thumbImg.removeAttribute('src');
        thumb.setAttribute('hidden', '');
      }
    }

    if (name) name.textContent = series.name || '';
    if (link) {
      link.textContent = (series.primaryCta || 'View').replace(/^\s*View\s+/i, 'View ');
      link.href = series.productUrl || series.seriesUrl || '#';
      link.setAttribute('data-series-key', seriesKey);
    }
  }

  function initSection(section) {
    var dataScript = section.querySelector('[data-wp-series-data]');
    var config = { defaultSeries: 'just_walk', series: [] };

    if (dataScript) {
      try {
        config = JSON.parse(dataScript.textContent);
      } catch (error) {
        config = { defaultSeries: 'just_walk', series: [] };
      }
    }

    var seriesByKey = {};
    config.series.forEach(function (item) {
      if (item && item.key) seriesByKey[item.key] = item;
    });

    var availableKeys = Object.keys(seriesByKey);
    var defaultFromBlock = config.series.find(function (item) { return item && item.isDefault; });
    var fallbackKey = (defaultFromBlock && defaultFromBlock.key) || config.defaultSeries || availableKeys[0] || 'just_walk';
    var answers = {};

    function refresh() {
      var hasAnswers = Object.keys(answers).length > 0;
      var ranked = rankSeries(section, seriesByKey, availableKeys, fallbackKey);

      // Before the first answer, show the configured default result. Only once the
      // user has answered do we surface the score-ranked match (with the price
      // tie-break). Otherwise the tie-break would pick the most expensive series
      // while every score is still zero, overriding the intended default.
      var primaryKey = hasAnswers && ranked[0] ? ranked[0].key : fallbackKey;
      updatePrimary(section, seriesByKey[primaryKey], primaryKey);

      // Only show secondary once user has made at least one selection,
      // and the second-ranked series is actually different from the primary.
      var secondaryKey = ranked[1] ? ranked[1].key : null;
      if (hasAnswers && secondaryKey && secondaryKey !== primaryKey) {
        updateSecondary(section, seriesByKey[secondaryKey], secondaryKey);
      } else {
        updateSecondary(section, null, null);
      }
    }

    refresh();

    section.querySelectorAll('.wp-selector-option').forEach(function (button) {
      button.addEventListener('click', function () {
        var question = button.closest('[data-question]');
        var questionKey = question ? question.getAttribute('data-question') : '';
        var answer = button.getAttribute('data-answer') || '';

        if (question) {
          question.querySelectorAll('.wp-selector-option').forEach(function (option) {
            option.classList.remove('is-selected');
          });
        }

        button.classList.add('is-selected');
        answers[questionKey] = answer;

        window.dispatchEvent(
          new CustomEvent('wp-series-selector:answer', {
            detail: {
              sectionId: section.getAttribute('data-section-id'),
              question: questionKey,
              answer: answer,
              answers: Object.assign({}, answers)
            }
          })
        );

        refresh();
      });
    });

    section.querySelectorAll('[data-cta-type]').forEach(function (link) {
      link.addEventListener('click', function () {
        window.dispatchEvent(
          new CustomEvent('wp-series-selector:cta-click', {
            detail: {
              sectionId: section.getAttribute('data-section-id'),
              ctaType: link.getAttribute('data-cta-type'),
              seriesKey:
                link.getAttribute('data-series-key') ||
                (section.querySelector('[data-result-series]') && section.querySelector('[data-result-series]').getAttribute('data-result-series')) ||
                '',
              href: link.href
            }
          })
        );
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-wp-series-selector]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
